import React from "react";
import { loadModules } from "esri-loader";
import axios from "axios";
import LoadingIndicator from "./LoadingIndicator";
import "@esri/calcite-components/dist/calcite/calcite.css"; // Import Calcite CSS
import "./InteractiveMap.css";
const baseURL = process.env.REACT_APP_API_BASE_URL;
const cleanBaseURL = baseURL?.replace("/api", "");
//import $ from 'jquery';
const options = { version: "4.27", css: true };
export class InteractiveMapSaagento extends React.Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.state = {
      loading: true,
      sidebarOpen: false,
      setSideBarOpen: false,
      showAlert: false, // New state to control the visibility of the alert
    };
  }

  handleViewSidebar = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen });
  };

  componentDidMount() {
    // this will lazy load the ArcGIS API
    // and then use Dojo's loader to require the classes
    loadModules(
      [
        "esri/config",
        "esri/core/urlUtils",
        "esri/views/MapView",
        "esri/Map",
        "esri/layers/MapImageLayer",
        "esri/layers/FeatureLayer",
        "esri/widgets/Popup",
      ],
      options
    ).then(
      ([
        esriConfig,
        urlUtils,
        MapView,
        Map,
        MapImageLayer,
        FeatureLayer,
        Popup,
      ]) => {
        // Define a pop-up for Trailheads

        esriConfig.request.corsDetection = false;
        esriConfig.request.proxyUrl =
          `${cleanBaseURL}/DotNet/proxy.ashx`;
        esriConfig.request.alwaysUseProxy = false;
        urlUtils.addProxyRule({
          urlPrefix: "https://gis.economy.ge/server/rest/services",
          proxyUrl: `${cleanBaseURL}/DotNet/proxy.ashx`
        });

        const popupfLayerII_III_stadia_point = {
          title: "{Obieqtis_Dasaxeleba}",
          content:
            "<b>ობიექტის დასახელება:</b> {Obieqtis_Dasaxeleba}<br><b>დამკვეთი:</b> {damkveti}",
        };
        const identifyURLTCSALayer =
          "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphics/MapServer";
        const TCSALayer = new MapImageLayer({
          url: identifyURLTCSALayer,
          title: "TCSA Layer",
        });
        // Define the query parameters
        const query = {
          where: "gancxadebis_nomeri LIKE '%398-2024%'", // Adjust 'your_text_here' with the text you want to search for
          outFields: ["*"],
          returnGeometry: true,
        };

        // then we load a web map from an id
        const map = new Map({
          basemap: "hybrid",
          layers: [TCSALayer],
        });

        // and we show that map in a container w/ id #viewDiv

        const view = new MapView({
          container: this.mapRef.current,
          map: map,
          center: [43.497273, 41.042451],
          popupEnabled: true,
          // popup: new Popup(),
          zoom: 7,
        });

        // When view is ready
        view.when().then(() => {
          // document.querySelector("calcite-loader").hidden = true;
        });
        const self = this;
        view.whenLayerView(TCSALayer).then((layerView) => {
          var layerDefinitionExpression;
          var hasGraphics = false;

          // Function to search sublayers
          const searchSublayers = async (layerSublayer, isSubSublayer) => {
            try {
              // Create the query and get the case number
              let query = layerSublayer.createQuery();
              const caseNumber = await getCaseNumberByID();

              // Create a new FeatureLayer with the given URL
              const featureLayerTEST = new FeatureLayer({
                url: layerSublayer.url,
              });

              // Construct the query expression
              var expression = "gancxadebis_nomeri LIKE '%" + caseNumber + "%'";
              query.where = expression;
              query.outFields = ["*"];
              featureLayerTEST.definitionExpression = expression;
              layerSublayer.definitionExpression = expression;

              // Query the features
              const response = await featureLayerTEST.queryFeatures(query);

              // Process the response
              if (response.features.length > 0) {
                hasGraphics = true;
                layerSublayer.visible = true;
                if (isSubSublayer) {
                  isSubSublayer.visible = true;
                }
                zoomToLayer(featureLayerTEST, view);
              }
            } catch (error) {
              console.error("Error querying features: ", error);
              //self.setState({ showAlert: true, loading: false });
            }
          };

          // Gather all promises from the map function
          const sublayerPromises = TCSALayer.sublayers.map(async (sublayer) => {
            if (sublayer.sublayers) {
              await Promise.all(
                sublayer.sublayers.map(async (subsublayer) => {
                  await searchSublayers(subsublayer, sublayer);
                })
              );
            }
            await searchSublayers(sublayer);
          });

          // Wait for all promises to resolve
          Promise.all(sublayerPromises).then(() => {
            if (hasGraphics) {
              this.setState({ showAlert: false, loading: false });
            } else {
              this.setState({ showAlert: true, loading: false });
            }
          });
        });
        // ვაწვდით პარამეტრად id-ს და აბრუნებს casenumber -ს
        async function getCaseNumberByID() {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          if (urlParams != "") {
            const id = urlParams.get("id");
            try {
              const params = {
                Id: id,
              };
              const response = await axios.get(`${baseURL}/GetCaseByIdByuser`, {
                params,
              });
              return response.data.data.caseNumber;
            } catch (error) { }
          }
        }

        const zoomToLayer = (layer, view) => {
          if (view.ready) {
            // View is ready, proceed with zooming to the layer
            return layer.queryExtent().then((response) => {
              if (response.count > 0) {
                this.setState({ showAlert: false });
                this.setState({ loading: false });
                //document.getElementsByClassName("NothingFoundOnMap")[0].style="display:none";
                ////document.getElementsByClassName("InteractiveMap")[0].style="display:block";
                view
                  .goTo({
                    target: response.extent,
                    //zoom: 20 // Adjust the zoom level as needed
                  })
                  .catch((error) => { });
              } else {
                // document.getElementsByClassName("NothingFoundOnMap")[0].style="visibility:visible";
                document.getElementsByClassName("InteractiveMap")[0].style =
                  "filter:blur(5px);";
                // document.getElementsByClassName("InteractiveMap")[0].style="display:none";
              }
            });
          } else {
            // View is not ready, wait for it to be loaded
            return view.when(() => {
              // Once the view is loaded, call zoomToLayer again
              return zoomToLayer(layer, view);
            });
          }
        };
      }
    );
  }

  render() {
    return (
      <div
        id="InteractiveMap"
        style={{ paddingBottom: "1px", height: "100%" }}
        className="InteractiveMap webmap"
        ref={this.mapRef}
      >
        {this.state.showAlert && (
          <div className="alert-container">
            <div>
              <p>ობიექტს არ აქვს მიბმული გრაფიკა!</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
